import { createSlice } from "@reduxjs/toolkit"
import { paymentModeFormObject } from "@form/paymentModeFormFields"

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    paymentModes: null,
    freeCodes: null,
    errors: [],
    paymentModeFormObject: { ...paymentModeFormObject }
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updatePaymentModes: (state, action) => {
      state.paymentModes = action.payload
    },
    updateFreeCodes: (state, action) => {
      state.freeCodes = action.payload
    },
    addFreeCode: (state, action) => {
      const freeCode = action.payload
      state.freeCodes = { ...state.freeCodes, [freeCode.id]: freeCode }
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    },
    updatePaymentModeFormObject: (state, action) => {
      state.paymentModeFormObject = action.payload
    },
    initPaymentModeFormObject: (state) => {
      state.paymentModeFormObject = { ...paymentModeFormObject }
    },
  }
})

export const {
  initPaymentModeFormObject,
  updatePaymentModeFormObject,
  fullUpdate,
  updatePaymentModes,
  updateFreeCodes,
  addFreeCode,
  updateErrors
} = paymentSlice.actions

export default paymentSlice.reducer